//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ConfirmState from'./components/confirmState.vue'
export default {
  components: {
    ConfirmState,
  },
  data(){
    return{
      currentVisible: false,
      title: '新增商品',
      upDateData: {},
      tableData: [],
      loading: false,
    }
  },
  mounted(){
    this.info()
  },

  methods:{
  info(){
    let data = {
      dealerId:window.sessionStorage.getItem('dealerId'),
      dShopId:this.$route.query.shopId
    }
    this.tableData = []
    this.$axios.post('/mtea/stock/tag/doGetsTagGoodsList',data).then(res=>{
      this.tableData = res
    })
  },
    handleFormSubmit(){
      let data = {
        tagGoodsName: this.upDateData.tagGoodsName,
      }
      if(this.upDateData.tagGoodsId){
        data.tagGoodsId = this.upDateData.tagGoodsId
      }
      this.$axios.post('/mtea/stock/tag/doModifyTagGoods',data).then(res=>{
        this.info()
        this.currentVisible = false
      })
    },
    upDateGoods(val, title){
      this.title = title
      this.currentVisible = true
      this.upDateData = val
    },
    handleDisplayRow(val){
      this.$axios.post('/mtea/stock/tag/doDelTagGoods',{ tagGoodsId: val.tagGoodsId }).then(()=>{
        this.loading = true
        this.info()
      })
    }
  }
}
